export default {
  apiRetryTimeout: 2000,
  maxApiRetryAttempts: 2,
  maxApiRetryError: 'Max number of API retries attempted',
}
